<template>
  <div class="edit-page">
    <div :class="current === 0 ? 'left-component-hidden' : 'left-component'">
      <ComponentChoose
        ref="componentChoose"
        :current="current"
        :pageObj="page"
        :project="project"
        @selectTab="selectTab"
        @showList="showList"
        @cancelLoading="cancelLoading"
      />
    </div>
    <div
      :class="
        current === 0 ? 'center-component-left-hidden' : 'center-component'
      "
    >
      <div class="center-header">
        <edit-page-top
          ref="editPageTop"
          :page="page"
          :project="project"
          :modeType="modeType"
          @changeMode="changeMode"
          @setProjectParams="setProjectParams"
        />
      </div>
    </div>

    <!-- <iframe id="iframe" width="100%" height="100%" src="/3000/preview/1" frameborder="0" ></iframe> -->
    
    <!-- 编辑模式 -->
    <div
      v-show="modeType != 'showCode'"
      :class="current === 0 ? 'center-content-left-hidden' : 'center-content'"
      id="centerContent"
      @click="cancelSelect"
    >
      <!-- <a-spin :spinning="spinning"> -->
      <div
        class="box"
        id="iframe-div"
        style="
          transform: translate(-50%, -50%) scale(1);
          display: none;
          text-align: center;
        "
      >
        <a-spin
          tip="加载中..."
          :spinning="spinning"
          style="top: 50%; position: relative; transform: translateY(-50%)"
          size="large"
        />
        <!-- <iframe style="display: none;" width="100%" height="100%" id="iframe-preview" src="http://www.baidu.com"/> -->
      </div>
      <!-- </a-spin> -->
      <div
        v-show="mouseShape == 'move'"
        class="box at-top"
        style="
          transform: translate(-50%, -50%) scale(1);
          backgroud: black;
          cursor: pointer;
        "
        id="iframe-div-top"
      ></div>
      <a-button class="mouse-click" @click="changeMouseShape('pointer')">
        <a-popover trigger="hover" placement="top">
          <template slot="content">选择</template>
          <img
            :src="mouseShape == 'move' ? mouseUnClickedImg : mouseClickedImg"
            style="width: 15.5px; height: 19.3px; text-align: center"
            alt=""
          />
        </a-popover>
      </a-button>
      <a-button class="hand-click" @click="changeMouseShape('move')">
        <a-popover trigger="hover" placement="top">
          <template slot="content">拖拽</template>
          <img
            :src="mouseShape == 'move' ? handClickedImg : handUnClickedImg"
            style="width: 19px; height: 20.4px; text-align: center"
            alt=""
          />
        </a-popover>
      </a-button>
      <a-button class="change-size-smaller" @click="zoomDrawBoard('smaller')">
        <a-popover trigger="hover" placement="top">
          <template slot="content">缩小</template>
          <img
            :src="reduceImg"
            style="width: 16px; height: 16px; text-align: center"
            alt=""
          />
        </a-popover>
      </a-button>
      <div
        class="draw-board-percent"
        id="divElement"
        @dblclick.stop="toReplace()"
      >
        {{ percentSize + "%" }}
      </div>
      <a-button class="change-size-bigger" @click="zoomDrawBoard('bigger')">
        <a-popover trigger="hover" placement="top">
          <template slot="content">放大</template>
          <img
            :src="enlargeImg"
            style="width: 16px; height: 16px; text-align: center"
            alt=""
          />
        </a-popover>
      </a-button>
    </div>

    <!-- 查看代码 -->
    <div
      v-show="modeType === 'showCode'"
      :class="current === 0 ? 'center-content-left-hidden' : 'center-content'"
      style="background: white"
    >
      <show-code ref="showCode" :page="page" />
    </div>

    <div class="mask" v-show="showCodeDrawer">
      <code-drawer  />
    </div>
    <div class="right-component">
      <edit-page-right :component="selectedComponent" />
    </div>
  </div>
</template>
<script>
import ComponentChoose from "@/views/edit-page/component-choose/ComponentChoose.vue";
import EditPageRight from "@/views/edit-page/edit-page-right/index.vue";
import EditPageTop from "@/views/edit-page/edit-page-top/index.vue";
import ShowCode from "@/views/edit-page/show-code/index.vue";
import CodeDrawer from "@/views/edit-page/code-drawer/index.vue";
import componentApi from "@/request/api-manager/component.js";
import projectApi from "@/request/api-manager/project.js";

import Page from "@/utils/Page.js";
import BlockComponent from "@/utils/BlockComponent.js";
import bus from "@/utils/Bus";

import Vue from "vue";
import { PAGE_UNDO_PREFIX, PAGE_REDO_PREFIX } from "@/store/mutation-types";
import { mapMutations } from "vuex";

export default {
  components: {
    EditPageRight,
    EditPageTop,
    ComponentChoose,
    ShowCode,
    CodeDrawer,
  },
  watch: {
    modeType(value) {
      if (value == "edit") {
        let self = this;
        self.moveClick();
      }
    },
  },
  name: "editPage",
  data() {
    return {
      curType: 1,
      current: 1,
      spinning: true,
      centerContentWidth: "", //画板最大宽度
      centerContentHeight: "", //画板最大高度
      page: null,
      pageObj: null,
      project: null,
      isResizable: false,
      isDraggable: false,
      percentSize: 100,
      mouseShape: "pointer",
      reduceImg: require("@/assets/edit-page/reduce.png"),
      enlargeImg: require("@/assets/edit-page/enlarge.png"),
      handClickedImg: require("@/assets/edit-page/handClicked.png"),
      handUnClickedImg: require("@/assets/edit-page/handUnClicked.png"),
      mouseUnClickedImg: require("@/assets/edit-page/mouseUnClicked.png"),
      mouseClickedImg: require("@/assets/edit-page/mouseClicked.png"),
      // 保存页面的page对象
      drawBoardWidth: undefined,
      drawBoardHeight: undefined,
      // 选中的组件
      selectedComponent: new BlockComponent(),
      modeType: "edit",
      showCodeDrawer:false,
    };
  },
  computed: {},
  async mounted() {
    let self = this;
    if (!self.getAndCheckRouteInfo()) return;
    self.getCenterContent();
    self.eventBusWatch();
    self.moveClick();
    self.addBusEventListener();

    // 获取页面数据，生成Page对象
    if (!(await self.getPageAndProject())) return;
    console.log("page-project", this.page, this.project);
    let pageId = this.page.id;
    self.setUndoList(Vue.ls.get(PAGE_UNDO_PREFIX + pageId) || []);
    self.setRedoList(Vue.ls.get(PAGE_REDO_PREFIX + pageId) || []);
    // 加载尺寸
    self.$refs.editPageTop.getSize();
    //生成page视图
    self.$refs.componentChoose.initPageLive();
  },
  methods: {
    ...mapMutations(["setUndoList", "setRedoList"]),
    /**
     * 路由处理
     * @return {Boolean} 校验结果
     */
    getAndCheckRouteInfo() {
      this.pageId = this.$route.query.pageId;
      if (!this.pageId || this.pageId == "") {
        this.$message.error("页面编号为空，请重新访问！");
        return false;
      }
      return true;
    },
    async getPageAndProject() {
      let pageRes = await componentApi.queryExtById({ id: this.pageId });
      if (!pageRes.result) {
        this.$message.error("页面不存在！");
        return false;
      }
      this.page = pageRes.result;

      let projectRes = await projectApi.queryById({ id: this.page.projectId });
      if (!projectRes.result) {
        this.$message.error("项目不存在！");
        return false;
      }
      this.project = projectRes.result;

      return true;
    },
    //获取中间元素最大值
    getCenterContent() {
      let self = this;
      var centerContent = document.getElementById("centerContent");
      self.centerContentWidth = centerContent.getBoundingClientRect().width;
      self.centerContentHeight = centerContent.getBoundingClientRect().height;
      console.log(self.centerContentWidth, self.centerContentHeight);
    },
    //监听画板大小
    eventBusWatch() {
      let self = this;
      self.$eventBus.$off();
      self.$eventBus.$on("size", (width, height) => {
        self.drawBoardWidth = width;
        self.drawBoardHeight = height;
        self.changeDrawBoard();
      });
    },
    cancelSelect(e) {
      console.log("e", e);
      let iframe = document.getElementById("iframe-div");
      if (e.target != iframe) {
        this.postMessage("", "cancel-select");
      }
    },
    postMessage(data, type) {
      let message = { data, type };
      console.log("send---", message);
      document
        .getElementById("iframe-preview")
        .contentWindow.postMessage(message, "*");
    },
    //改变画板
    changeDrawBoard() {
      let self = this;
      var dragTop = document.getElementById("iframe-div-top"); //获取覆盖画板的元素
      var drag = document.getElementById("iframe-div"); //获取画板元素
      drag.style.display = "block";
      let divElement = document.getElementById("divElement");
      let percent = 100; //设置默认放大百分比为100%
      if (
        self.centerContentWidth > self.drawBoardWidth &&
        self.centerContentHeight > self.drawBoardHeight
      ) {
        self.setWidthHeightTransForm(drag, 1);
        self.setWidthHeightTransForm(dragTop, 1);
        self.percentSize = 100;
      } else {
        self.percentSize = self.changePercent(percent);
        percent = parseFloat(self.percentSize / 100);
        self.setWidthHeightTransForm(drag, percent);
        self.setWidthHeightTransForm(dragTop, percent);
      }
      divElement.innerHTML = self.percentSize + "%";
    },
    //设置画板宽高和缩放
    setWidthHeightTransForm(divElement, percent) {
      let self = this;
      divElement.style.width = self.drawBoardWidth + "px";
      divElement.style.height = self.drawBoardHeight + "px";
      divElement.style.transform = `translate(-50%, -50%) scale(${percent})`;
    },
    //将超过背景大小的尺寸按照宽高中的最小比例缩放
    changePercent(percent) {
      let self = this;
      let widthScale = Math.floor(
        parseFloat((self.centerContentWidth * 100) / self.drawBoardWidth)
      ); //比例向下取整
      let heightScale = Math.floor(
        parseFloat((self.centerContentHeight * 100) / self.drawBoardHeight)
      ); //比例向下取整
      percent = Math.min(widthScale, heightScale);
      return percent;
    },
    //缩放画板
    zoomDrawBoard(change) {
      let self = this;
      var dragTop = document.getElementById("iframe-div-top"); //获取覆盖画板的元素
      var drag = document.getElementById("iframe-div");
      let divElement = document.getElementById("divElement");
      if (change === "smaller") {
        //点击缩小按钮
        if (self.percentSize > 0) {
          self.percentSize = self.isInteger(parseFloat(self.percentSize / 10))
            ? (parseFloat(self.percentSize / 10) - 1) * 10
            : Math.floor(parseFloat(self.percentSize / 10)) * 10; //缩放比例向下取整
        } else {
          self.$message.warning("缩放比例不能小于0");
        }
      } else if (change === "bigger") {
        //点击放大按钮
        self.percentSize = self.isInteger(parseFloat(self.percentSize / 10))
          ? (parseFloat(self.percentSize / 10) + 1) * 10
          : Math.ceil(parseFloat(self.percentSize / 10)) * 10; // 缩放比例向上取整
      }
      let percent = parseFloat(self.percentSize / 100);
      divElement.innerHTML = self.percentSize + "%";
      drag.style.transform = `translate(-50%, -50%) scale(${percent})`;
      dragTop.style.transform = `translate(-50%, -50%) scale(${percent})`;
      console.log("1231231233123", dragTop.style.transform);
    },
    addBusEventListener() {
      let self = this;
      bus.$on("select-component", (blockComponent) => {
        self.selectedComponent = blockComponent;
        self.$set(self, "selectedComponent", blockComponent);
        console.log(`选择组件：`, self.selectedComponent);
      });
      bus.$on("cancel-select", (page) => {
        self.selectedComponent = page;
        self.$set(self, "selectedComponent", page);
      });
      bus.$on("update-component", (component) => {
        Object.assign(self.selectedComponent, component);
      });
      bus.$on("save-component", (component) => {
        // 渲染
        self.$refs.componentChoose.updatePage().then(() => {
          self.$message.success("保存成功！");
        });
      });
      bus.$on("post-message", (data, type) => {
        self.postMessage(data, type);
      });
      bus.$on('code-drawer',(show) => {
        self.showCodeDrawer = show;
        console.log('听到了些什么',show)
      })
    },
    selectTab(value) {
      let self = this;
      self.current = value;
    },
    showList() {
      let self = this;
      self.current = self.current === 0 ? 1 : 0;
    },
    setProjectParams(params) {
      this.project.params = params;
    },
    resize(newRect) {
      let self = this;
      self.vw = newRect.width;
      self.vh = newRect.height;
      self.top = newRect.top;
      self.left = newRect.left;
    },
    moveClick() {
      let self = this;
      var dragTop = document.getElementById("iframe-div-top");
      let putDown = function (event) {
        var event = event || window.event;
        if (event.button != 0) {
          //判断是否是鼠标左键点击
          return;
        }
        console.log("鼠标左键点击事件", event);
        self.mouseClickAndMove(dragTop, event);
        self.mouseClickUp(dragTop);
      };

      dragTop.addEventListener("mousedown", putDown, false);
    },
    //右键长按点击移动
    mouseClickAndMove(dragTop, event) {
      dragTop.style.cursor = "move";
      let offsetX = parseInt(dragTop.getBoundingClientRect().left); // x轴距离
      let offsetY = parseInt(dragTop.getBoundingClientRect().top); // y轴距离
      var centerContent = document.getElementById("centerContent"); //获取中心布局的绝对定位属性
      let centerContentOffsetX = centerContent.getBoundingClientRect().left;
      let centerContentOffsetY = centerContent.getBoundingClientRect().top;
      var drag = document.getElementById("iframe-div");
      let innerX = event.clientX; // 鼠标x轴距
      let innerY = event.clientY; // 鼠标y轴距
      // 移动时显示边框
      let dragHeight = dragTop.getBoundingClientRect().height / 2; //获取margin高度
      let dragWidth = dragTop.getBoundingClientRect().width / 2; //获取margin宽度
      let xChange = 0; //鼠标按下后相对移动横轴距离
      let yChange = 0; //鼠标按下后相对移动纵轴距离
      document.onmousemove = function (event) {
        xChange = parseInt(event.clientX - innerX);
        yChange = parseInt(event.clientY - innerY);
        dragTop.style.left =
          parseInt(xChange + offsetX - centerContentOffsetX + dragWidth) + "px";
        dragTop.style.top =
          parseInt(yChange + offsetY - centerContentOffsetY + dragHeight) +
          "px";
        drag.style.left =
          parseInt(xChange + offsetX - centerContentOffsetX + dragWidth) + "px";
        drag.style.top =
          parseInt(yChange + offsetY - centerContentOffsetY + dragHeight) +
          "px";
      };
    },
    //右键点击结束
    mouseClickUp(drag) {
      document.onmouseup = function () {
        var event = event || window.event;
        if (event.button != 0) {
          return;
        }
        document.onmousemove = null;
        document.onmouseup = null;
        drag.style.borderStyle = "";
        drag.style.borderColor = "";
        drag.style.borderWidth = "";
        drag.style.cursor = "pointer";
      };
    },
    toReplace() {
      // 创建一个input元素
      let self = this;
      let divElement = document.getElementById("divElement");
      console.log("divElement", divElement.innerHTML.split("%")[0]);
      var inputElement = document.createElement("input");
      // 把obj里面的元素以及文本内容赋值给新建的inputElement
      self.setInputElementStyle(inputElement);
      // 用新建的inputElement代替原来的oldDivElement元素
      divElement.parentNode.replaceChild(inputElement, divElement);
      // 当inputElement失去焦点时触发下面函数，使得input变成div
      self.inputElementOnlur(inputElement, divElement, self);
    },
    //设置输入框样式
    setInputElementStyle(inputElement) {
      inputElement.style.width = "40px";
      inputElement.style.height = "27px";
      inputElement.style.left = "156px";
      inputElement.style.bottom = "37px";
      inputElement.style.position = "absolute";
      inputElement.style.fontFamily = "PingFangSC-Medium";
      inputElement.style.fontSize = "14px";
      inputElement.style.color = "rgba(0, 0, 0, 0.40)";
      inputElement.style.textAlign = "center";
      inputElement.value = divElement.innerHTML.split("%")[0];
      inputElement.setAttribute("maxlength", "3");
    },
    //放大比例输入框失去焦点方法
    inputElementOnlur(inputElement, divElement, self) {
      inputElement.onblur = function () {
        //把input的值交给原来的div
        const ifInteger = /^[0-9]*[1-9][0-9]*$/;
        if (ifInteger.test(inputElement.value)) {
          //检验是否为正整数
          self.percentSize = inputElement.value;
          divElement.innerHTML = self.percentSize + "%";
          var drag = document.getElementById("iframe-div");
          let percent = parseFloat(self.percentSize / 100);
          drag.style.transform = `translate(-50%, -50%) scale(${percent})`;
        } else {
          self.$message.error("请输入正整数");
          divElement.innerHTML = self.percentSize + "%";
        }
        //用原来的div重新替换inputElement
        inputElement.parentNode.replaceChild(divElement, inputElement);
      };
    },
    //模式选择
    changeMode(mode) {
      this.modeType = mode;
      let iframePreview = document.getElementById("iframe-preview");
      let iframePage = document.getElementById("iframe-page");
      if (mode == "edit") {
        iframePage.style.display = "none";
        iframePreview.style.display = "block";
      } else if (mode == "preview") {
        iframePreview.style.display = "none";
        iframePage.style.display = "block";
      } else if (mode == "showCode") {
        this.$refs.showCode.getPageCode();
      }
    },
    changeMouseShape(shape) {
      this.mouseShape = shape;
    },
    cancelLoading() {
      this.spinning = false;
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.css";
</style>